import { Grid2 } from '@mui/material'
import styled from 'styled-components'

export const LoadConfirmFormContainer = styled(Grid2)<{ $compact?: boolean }>`
  margin-top: ${({ $compact }) => ($compact ? '8px' : '30px')};
  padding-left: ${({ $compact }) => ($compact ? '20px' : '30px')};
  padding-right: ${({ $compact }) => ($compact ? '20px' : '30px')};
`
